import { Skeleton } from '@/components/ui/skeleton';

export const SearchAndCategoriesSkeleton = () => {
  return (
    <div className="mb-6">
      {/* Search input skeleton */}
      <div className="relative mb-4">
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      
      {/* Categories skeleton */}
      <div className="flex items-center space-x-2 overflow-x-auto pb-2 no-scrollbar">
        <Skeleton className="h-8 w-32 rounded-md" />
        <Skeleton className="h-8 w-28 rounded-md" />
        <Skeleton className="h-8 w-24 rounded-md" />
        <Skeleton className="h-8 w-20 rounded-md" />
      </div>
    </div>
  );
}; 